export const TRANSLATIONS_DIR_NAMESPACE = "translations";

// This route is determined by translationOutputDir in configUtils
export const TRANSLATION_ROUTE = `/${TRANSLATIONS_DIR_NAMESPACE}`;

export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";
export const UNAUTHORISED_TIMEOUT = 10; // Seconds
export const AUTO_CLOSURE_TIMEOUT = 5; // Seconds
export const LANGUAGE_RESET_TIMEOUT = 30; // Seconds
export const HEARTBEAT_INTERVAL_SECONDS = 900; // 15 minutes